// extracted by mini-css-extract-plugin
module.exports = {"menuToggle":"X_cT","open":"X_cL","close":"X_bN","light":"X_s","hamburger":"X_cV","cross":"X_cW"};